function ArrowBoardVector() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="472"
      height="327"
      fill="none"
      viewBox="0 0 472 327"
    >
      <path
        fill="#C0CCD8"
        d="M357.26 327c63.369 0 114.74-3.499 114.74-7.815 0-4.315-51.371-7.814-114.74-7.814-63.368 0-114.739 3.499-114.739 7.814 0 4.316 51.371 7.815 114.739 7.815zM156.164 321.98c46.237 0 83.719-1.249 83.719-2.791 0-1.541-37.482-2.791-83.719-2.791-46.236 0-83.719 1.25-83.719 2.791 0 1.542 37.483 2.791 83.719 2.791z"
      ></path>
      <path
        fill="#C0CCD8"
        d="M198.814 322.089c46.237 0 83.719-1.249 83.719-2.79 0-1.542-37.482-2.791-83.719-2.791-46.237 0-83.719 1.249-83.719 2.791 0 1.541 37.482 2.79 83.719 2.79z"
      ></path>
      <path
        fill="#C0CCD8"
        d="M95.85 320.413c19.836 0 35.916-.642 35.916-1.435 0-.792-16.08-1.435-35.916-1.435s-35.916.643-35.916 1.435c0 .793 16.08 1.435 35.916 1.435z"
      ></path>
      <path
        fill="#D8984A"
        d="M350.608 319.062l14.158-135.6-19.086-1.962-12.366 118.425c-1.072 10.238 6.975 19.137 17.294 19.137z"
      ></path>
      <path
        fill="#AA7133"
        d="M350.593 319.061c8.303 0 15.278-6.251 16.142-14.496l12.719-120.785-14.671-.319-14.19 135.6zM280.408 319.059c8.303 0 15.278-6.251 16.142-14.496l12.607-119.86-14.863.176-13.886 134.18z"
      ></path>
      <path
        fill="#D8984A"
        d="M280.407 319.06l13.87-134.165-19.086-1.961-12.094 116.989c-1.056 10.238 6.991 19.137 17.31 19.137z"
      ></path>
      <path
        fill="#845124"
        d="M429.015 319.056c7.647 0 13.198-7.224 11.231-14.576L385.98 101.773l-14.319 4.019 57.354 213.264z"
      ></path>
      <path
        fill="#000"
        fillOpacity="0.2"
        d="M385.98 101.773l-14.319 4.019 32.333 120.211a225.832 225.832 0 009.471-21.577L385.98 101.773z"
        opacity="0.5"
      ></path>
      <path
        fill="#AF7337"
        d="M429.015 319.053l-57.353-213.264-18.942 3.046 51.194 191.001c3.04 11.339 13.343 19.217 25.101 19.217z"
      ></path>
      <path
        fill="#000"
        fillOpacity="0.2"
        d="M371.662 105.789l-18.942 3.046 37.708 140.671A232.636 232.636 0 00403.994 226l-32.332-120.211z"
        opacity="0.5"
      ></path>
      <path
        fill="#9A5633"
        d="M388.551 166.854c15.815-69.103-3.109-132.341-42.268-141.246-39.158-8.904-83.723 39.896-99.537 109-15.815 69.103 3.109 132.341 42.267 141.246 39.159 8.904 83.723-39.896 99.538-109z"
      ></path>
      <path
        fill="#930F0F"
        d="M360.319 28.76l-14.095-3.205a42.838 42.838 0 018.431 2.886l14.095 3.206c-2.752-1.276-5.568-2.249-8.431-2.887z"
      ></path>
      <path
        fill="#930F0F"
        d="M289.127 275.864l14.094 3.206c35.341 8.037 76.584-31.576 95.478-94.042 20.43-67.521 7.023-136.19-29.949-153.381l-14.094-3.206c36.972 17.176 50.362 85.845 29.949 153.382-18.91 62.465-60.138 102.079-95.478 94.041z"
      ></path>
      <path
        fill="#EA5757"
        d="M288.23 248.01c-7.199-3.349-13.39-9.153-18.414-17.271-4.863-7.846-8.431-17.51-10.623-28.737-2.191-11.227-2.879-23.41-2.063-36.248.848-13.268 3.295-26.664 7.279-39.805 3.983-13.14 9.231-25.228 15.63-35.929 6.191-10.334 13.183-18.961 20.782-25.627s15.422-11.036 23.245-12.997c8.095-2.026 15.839-1.34 23.038 1.993 7.199 3.35 13.39 9.154 18.414 17.271 4.863 7.846 8.431 17.51 10.623 28.737 2.191 11.227 2.879 23.411 2.063 36.248-.848 13.269-3.295 26.664-7.279 39.805-3.983 13.141-9.231 25.229-15.63 35.929-6.191 10.334-13.183 18.962-20.782 25.628s-15.422 11.035-23.245 12.997c-8.079 2.009-15.839 1.339-23.038-1.994zm66.425-219.578c-36.956-17.176-83.479 23.634-103.909 91.154-20.429 67.521-7.023 136.191 29.949 153.382 36.972 17.175 83.495-23.634 103.925-91.155 20.413-67.537 7.007-136.19-29.965-153.381z"
      ></path>
      <path
        fill="#fff"
        d="M295.781 223.037c-5.36-2.487-9.967-6.809-13.695-12.821-3.615-5.837-6.271-13.029-7.903-21.386-1.632-8.356-2.144-17.43-1.536-26.967.624-9.839 2.448-19.79 5.408-29.582 2.959-9.792 6.863-18.77 11.614-26.696 4.592-7.686 9.791-14.097 15.455-19.057 5.663-4.96 11.486-8.213 17.294-9.664 5.999-1.499 11.758-.989 17.118 1.5 5.359 2.487 9.967 6.809 13.694 12.82 3.616 5.838 6.272 13.03 7.903 21.386 1.632 8.357 2.144 17.431 1.536 26.967-.624 9.84-2.447 19.791-5.407 29.582-2.96 9.792-6.863 18.77-11.615 26.712-4.591 7.687-9.791 14.098-15.454 19.057-5.664 4.96-11.487 8.213-17.294 9.664-6 1.483-11.759.989-17.118-1.515zM347.103 53.39c-7.199-3.35-14.942-4.02-23.037-1.994-7.824 1.946-15.647 6.331-23.246 12.997-7.599 6.666-14.59 15.294-20.782 25.628-6.399 10.684-11.662 22.772-15.63 35.929-3.983 13.141-6.431 26.536-7.279 39.805-.816 12.837-.128 25.021 2.064 36.248 2.191 11.227 5.759 20.891 10.622 28.737 5.024 8.117 11.215 13.922 18.414 17.271 7.2 3.349 14.943 4.019 23.038 1.993 7.823-1.945 15.646-6.331 23.245-12.997 7.6-6.666 14.591-15.293 20.782-25.627 6.399-10.685 11.663-22.773 15.63-35.929 3.984-13.141 6.432-26.537 7.28-39.805.816-12.838.128-25.021-2.064-36.248-2.192-11.227-5.76-20.891-10.623-28.737-5.007-8.118-11.215-13.922-18.414-17.271z"
      ></path>
      <path
        fill="#EA5757"
        d="M303.333 198.076c-3.52-1.643-6.544-4.449-8.959-8.372-2.368-3.812-4.112-8.532-5.184-14.018-1.072-5.486-1.408-11.434-1.008-17.67.416-6.411 1.6-12.933 3.552-19.36s4.495-12.311 7.599-17.478c3.008-5.024 6.415-9.234 10.143-12.487 3.728-3.269 7.535-5.406 11.343-6.347 3.919-.973 7.679-.638 11.198.989 3.52 1.642 6.544 4.449 8.976 8.388 2.367 3.812 4.111 8.532 5.183 14.018 1.072 5.486 1.408 11.434 1.008 17.669-.416 6.411-1.6 12.934-3.552 19.361-1.952 6.426-4.495 12.311-7.599 17.478-3.008 5.023-6.415 9.233-10.143 12.487-3.711 3.269-7.535 5.39-11.343 6.347-3.919.972-7.695.637-11.214-1.005zm36.22-119.733c-5.36-2.487-11.119-2.998-17.118-1.499-5.808 1.452-11.631 4.705-17.295 9.664-5.663 4.96-10.862 11.387-15.454 19.057-4.751 7.926-8.655 16.921-11.615 26.696-2.959 9.792-4.783 19.743-5.407 29.583-.608 9.536-.096 18.61 1.536 26.966 1.632 8.357 4.287 15.549 7.903 21.386 3.728 6.012 8.335 10.334 13.694 12.821 5.36 2.488 11.119 2.999 17.119 1.5 5.807-1.452 11.63-4.705 17.294-9.665 5.663-4.959 10.862-11.386 15.454-19.057 4.751-7.925 8.655-16.92 11.615-26.711 2.959-9.792 4.783-19.743 5.407-29.583.608-9.536.096-18.61-1.536-26.967-1.632-8.356-4.287-15.548-7.903-21.385-3.727-5.996-8.335-10.302-13.694-12.806z"
      ></path>
      <path
        fill="#fff"
        d="M310.882 173.122c-1.679-.781-3.103-2.105-4.239-3.939-1.12-1.802-1.936-4.05-2.448-6.666-.512-2.631-.672-5.454-.496-8.388.192-2.998.768-6.06 1.696-9.138.928-3.078 2.128-5.852 3.568-8.26 1.424-2.377 3.039-4.37 4.815-5.933 1.776-1.563 3.584-2.583 5.392-3.03 1.823-.446 3.599-.287 5.279.494 1.68.782 3.104 2.106 4.239 3.939 1.12 1.803 1.936 4.051 2.448 6.666.512 2.632.672 5.454.496 8.389-.192 2.998-.768 6.06-1.696 9.138-.928 3.077-2.127 5.852-3.567 8.26-1.424 2.376-3.04 4.37-4.816 5.933-1.776 1.563-3.583 2.583-5.391 3.03a7.722 7.722 0 01-5.28-.495zM332 103.321c-3.519-1.643-7.295-1.978-11.199-.989-3.807.957-7.615 3.094-11.342 6.347-3.712 3.269-7.136 7.464-10.143 12.487-3.088 5.167-5.648 11.051-7.599 17.478-1.952 6.427-3.136 12.949-3.552 19.36-.4 6.236-.064 12.184 1.008 17.67 1.072 5.486 2.816 10.206 5.183 14.018 2.432 3.923 5.44 6.745 8.959 8.372 3.52 1.643 7.296 1.977 11.199.989 3.808-.957 7.615-3.078 11.343-6.347 3.711-3.27 7.135-7.464 10.143-12.487 3.087-5.167 5.647-11.052 7.599-17.478 1.952-6.427 3.136-12.95 3.551-19.36.4-6.236.064-12.184-1.007-17.67-1.072-5.486-2.816-10.206-5.184-14.018-2.416-3.923-5.439-6.746-8.959-8.372z"
      ></path>
      <path
        fill="#EA5757"
        d="M324.45 128.279c1.68.781 3.104 2.105 4.24 3.939 1.119 1.802 1.935 4.05 2.447 6.666.512 2.631.672 5.454.496 8.388-.192 2.998-.768 6.06-1.696 9.138-.927 3.078-2.127 5.852-3.567 8.26-1.424 2.377-3.04 4.37-4.816 5.933-1.775 1.563-3.583 2.583-5.391 3.03a7.722 7.722 0 01-5.28-.495c-1.679-.781-3.103-2.105-4.239-3.939-1.12-1.802-1.936-4.05-2.448-6.666-.512-2.631-.672-5.454-.496-8.388.192-2.998.768-6.06 1.696-9.138.928-3.077 2.128-5.852 3.568-8.26 1.424-2.377 3.039-4.37 4.815-5.933 1.776-1.563 3.584-2.583 5.392-3.03a7.72 7.72 0 015.279.495z"
      ></path>
      <path
        fill="#000"
        fillOpacity="0.2"
        d="M294.166 276.685l90.662-177.462.4.223-.528 1.084-76.264 175.214c-4.783 1.068-9.566 1.403-14.27.941zM253.129 243.149c18.59-29.678 58.714-93.165 58.714-93.165l-.24 1.18L258.28 252.43c-1.855-2.886-3.567-5.996-5.151-9.281z"
        opacity="0.8"
      ></path>
      <path
        fill="#B21212"
        d="M116.138 119.719l-5.727-1.228 8.927-9.393 29.101 6.267-8.944 9.393-21.309-4.593 4.111-5.47-6.159 5.024z"
      ></path>
      <path
        fill="#D83D3D"
        d="M144.199 103.134l4.24 12.232-29.101-6.267-4.24-12.232 29.101 6.267z"
      ></path>
      <path
        fill="#724E2E"
        d="M307.813 151.488c.8 0 1.536-.558 1.712-1.371.208-.941-.4-1.866-1.344-2.073l-188.939-40.73a1.752 1.752 0 00-2.08 1.34c-.208.941.4 1.866 1.344 2.073l188.939 40.729c.128.016.24.032.368.032z"
      ></path>
      <path
        fill="#3F3F3F"
        d="M293.958 149.114l12.959 2.791c1.136.239 2.272-.479 2.512-1.611l.08-.399c.24-1.132-.48-2.264-1.616-2.504l-12.959-2.79c-1.136-.24-2.271.478-2.511 1.61l-.08.399c-.256 1.132.464 2.249 1.615 2.504z"
      ></path>
      <path
        fill="#3F3F3F"
        d="M309.412 149.316l2.448.67-.24 1.18-2.528-.398.32-1.452z"
      ></path>
      <path
        fill="#2E7DCC"
        d="M202.864 22.391l-5.248-2.583 10.975-6.921 26.669 13.172-10.975 6.921-19.534-9.648 5.328-4.29-7.215 3.35z"
      ></path>
      <path
        fill="#4C9DED"
        d="M214.975 3.7l5.711 10.605c-.288-2.743-.576-5.47-.88-8.213l14.319 7.08 1.12 12.902-26.67-13.173L207.456 0l7.519 3.7z"
      ></path>
      <path
        fill="#AA753F"
        d="M380.941 99.912a1.765 1.765 0 001.999-.925 1.74 1.74 0 00-.8-2.344L208.943 11.102a1.751 1.751 0 00-2.352.797 1.741 1.741 0 00.8 2.344l173.214 85.558c.096.047.224.08.336.111z"
      ></path>
      <path
        fill="#3F3F3F"
        d="M368.079 94.231l11.87 5.869c1.04.51 2.32.095 2.832-.957l.176-.367a2.102 2.102 0 00-.96-2.823l-11.871-5.868c-1.039-.51-2.319-.096-2.831.957l-.176.366a2.115 2.115 0 00.96 2.823z"
      ></path>
      <path
        fill="#3F3F3F"
        d="M383.02 98.203l2.207 1.244-.527 1.084-2.336-.988.656-1.34z"
      ></path>
      <path
        fill="#2E7DCC"
        d="M218.205 220.249l11.63-5.757 25.15 15.868-11.631 5.757-25.149-15.868z"
      ></path>
      <path
        fill="#4C9DED"
        d="M255.225 217.426l-.24 12.933-25.15-15.867.24-12.933 25.15 15.867z"
      ></path>
      <path
        fill="#724E2E"
        d="M392.778 319.009a1.77 1.77 0 001.488-.813 1.747 1.747 0 00-.544-2.408l-163.358-103.02a1.76 1.76 0 00-2.416.542 1.747 1.747 0 00.544 2.408l163.358 103.02c.288.191.608.271.928.271z"
      ></path>
      <path
        fill="#3F3F3F"
        d="M379.996 311.93l11.199 7.065a2.106 2.106 0 002.911-.654l.208-.335a2.091 2.091 0 00-.656-2.902l-11.199-7.065a2.106 2.106 0 00-2.911.654l-.208.335a2.095 2.095 0 00.656 2.902z"
      ></path>
      <path
        fill="#3F3F3F"
        d="M394.314 319.056l-.672-.366.784-1.26 2.304 1.626h-2.416z"
      ></path>
      <path
        fill="#2E7DCC"
        d="M61.774 216.885l-4.831-3.301 11.839-5.295 24.525 16.825-11.855 5.294-17.95-12.327 5.887-3.493-7.615 2.297z"
      ></path>
      <path
        fill="#4C9DED"
        d="M76.428 200.107l4.144 11.307c.096-2.743.208-5.502.304-8.245l13.166 9.042-.736 12.917-24.51-16.824.737-12.917 6.895 4.72z"
      ></path>
      <path
        fill="#724E2E"
        d="M227.58 319.057c.56 0 1.104-.271 1.44-.749a1.737 1.737 0 00-.448-2.424L69.374 206.581c-.8-.542-1.888-.351-2.432.446a1.737 1.737 0 00.448 2.424l159.183 109.303c.32.208.671.303 1.007.303z"
      ></path>
      <path
        fill="#3F3F3F"
        d="M215.007 311.48l10.91 7.496c.96.653 2.272.414 2.944-.543l.224-.335a2.116 2.116 0 00-.544-2.934l-10.911-7.495a2.13 2.13 0 00-2.943.542l-.224.335a2.114 2.114 0 00.544 2.934z"
      ></path>
      <path
        fill="#3F3F3F"
        d="M228.86 319.058l-.48-.287.848-1.228 1.968 1.515h-2.336z"
      ></path>
      <path
        fill="#2E7DCC"
        d="M88.028 211.016l12.047-4.864 23.869 17.734-12.047 4.848-23.87-17.718z"
      ></path>
      <path
        fill="#4C9DED"
        d="M108.009 198.257l3.711 11.45.624-8.229 12.815 9.521-1.216 12.885-23.869-17.733 1.216-12.885 6.719 4.991z"
      ></path>
      <path
        fill="#AA753F"
        d="M249.161 319.058L98.65 207.268a1.719 1.719 0 01-.352-2.44c.576-.766 1.68-.941 2.447-.351l154.288 114.581h-5.872z"
      ></path>
      <path
        fill="#3F3F3F"
        d="M248.219 319.055l-5.711-4.241a2.325 2.325 0 01-.48-3.238 2.342 2.342 0 013.248-.478l10.302 7.654c.112.08.224.176.32.288h-7.679v.015z"
      ></path>
      <path
        fill="#2E7DCC"
        d="M.822 154.978l12.99-.255 15.951 25.053-12.975.255L.822 154.978z"
      ></path>
      <path
        fill="#4C9DED"
        d="M35.524 168.163l-5.76 11.609-15.95-25.053 5.743-11.61 15.967 25.054z"
      ></path>
      <path
        fill="#AA753F"
        d="M117.163 318.734c.32 0 .64-.095.943-.271a1.747 1.747 0 00.544-2.408L15.03 153.377a1.76 1.76 0 00-2.416-.543 1.747 1.747 0 00-.544 2.408l103.605 162.679a1.75 1.75 0 001.488.813z"
      ></path>
      <path
        fill="#3F3F3F"
        d="M107.867 306.711l7.103 11.163a2.11 2.11 0 002.912.654l.335-.207a2.096 2.096 0 00.656-2.903l-7.103-11.163a2.11 2.11 0 00-2.911-.654l-.336.208a2.094 2.094 0 00-.656 2.902z"
      ></path>
      <path
        fill="#3F3F3F"
        d="M117.627 319.056l-.304-.415 1.248-.797.688 1.212h-1.632z"
      ></path>
      <path
        fill="#2E7DCC"
        d="M129.991 144.449l12.863 1.707 11.983 27.158-12.863-1.706-11.983-27.159z"
      ></path>
      <path
        fill="#4C9DED"
        d="M153.669 143.19l-2.432 11.785c1.536-2.281 3.072-4.577 4.608-6.858l6.431 14.592-7.439 10.605-11.983-27.158 7.439-10.605 3.376 7.639z"
      ></path>
      <path
        fill="#724E2E"
        d="M217.228 319.06L141.06 146.43a1.746 1.746 0 01.896-2.296c.88-.383 1.92.016 2.304.893l76.792 174.049h-3.824v-.016z"
      ></path>
      <path
        fill="#3F3F3F"
        d="M216.622 319.057l-3.679-8.324a2.313 2.313 0 011.183-3.046c1.168-.51 2.544.016 3.056 1.18l4.496 10.19h-5.056z"
      ></path>
    </svg>
  );
}

export default ArrowBoardVector;
